var _style, _circle, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFaq(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#FFFFFF",
    stroke: "currentColor",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 170 170",
    style: {
      enableBackground: "new 0 0 170 170"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 134.6,
    cy: 162.9,
    r: 7.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M170,92c0,17.2-12.2,31.5-28.4,34.7v14.9c0,3.9-3.2,7.1-7.1,7.1c-3.9,0-7.1-3.2-7.1-7.1v-21.3 c0-3.9,3.2-7.1,7.1-7.1c11.7,0,21.3-9.6,21.3-21.3s-9.6-21.3-21.3-21.3s-21.3,9.6-21.3,21.3c0,3.9-3.2,7.1-7.1,7.1 c-3.9,0-7.1-3.2-7.1-7.1c0-19.6,15.9-35.4,35.4-35.4S170,72.4,170,92z M56.6,49.5H35.3c-3.9,0-7.1-3.2-7.1-7.1s3.2-7.1,7.1-7.1h21.3 c3.9,0,7.1,3.2,7.1,7.1S60.5,49.5,56.6,49.5z M84.9,70.7c0,3.9-3.2,7.1-7.1,7.1H35.3c-3.9,0-7.1-3.2-7.1-7.1s3.2-7.1,7.1-7.1h42.5 C81.7,63.7,84.9,66.8,84.9,70.7z M84.9,99.1c0,3.9-3.2,7.1-7.1,7.1H35.3c-3.9,0-7.1-3.2-7.1-7.1s3.2-7.1,7.1-7.1h42.5 C81.7,92,84.9,95.2,84.9,99.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M127.5,14v21c0,3.9-3.2,7.1-7.1,7.1c-3.9,0-7.1-3.2-7.1-7.1V17.6c0-2-1.6-3.5-3.5-3.5H17.6 c-2,0-3.5,1.6-3.5,3.5v134.7c0,2,1.5,3.5,3.5,3.5h88.7c3.9,0,7.1,3.2,7.1,7.1s-3.2,7.1-7.1,7.1H14c-7.8,0-14.2-6.4-14.2-14.2V14 C-0.1,6.2,6.2-0.1,14-0.1h99.3C121.1-0.1,127.5,6.2,127.5,14z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M84.9,127.5c0,3.9-3.2,7.1-7.1,7.1H35.3c-3.9,0-7.1-3.2-7.1-7.1s3.2-7.1,7.1-7.1h42.5 C81.7,120.4,84.9,123.6,84.9,127.5z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaq);
export default __webpack_public_path__ + "static/media/FAQ.58a6153ca18123b04876cea7d0e5dac0.svg";
export { ForwardRef as ReactComponent };